// AJAX Add to Cart with Success Message
document.querySelectorAll('.add-to-cart-btn').forEach(function(button) {
  button.addEventListener('click', function(event) {
    event.preventDefault();

    var variantId = this.getAttribute('data-variant-id');
    var quantity = 1; // Default quantity to 1

    // AJAX request to add product to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      // Show success message for the specific product
      showSuccessMessage(this);  // Pass the button as argument

      // Update the mini cart with the new cart items
      updateMiniCart();
    })
    .catch(error => console.error('Error:', error));
  });
});

// Handle Bundle Add to Cart Forms (bp-bundles-featured)
document.querySelectorAll('.bundle-add-to-cart-form').forEach(function(form) {
  form.addEventListener('submit', function(event) {
    event.preventDefault();
    event.stopPropagation();

    const button = this.querySelector('.bundle-cart-btn');
    const variantId = button.getAttribute('data-variant-id');
    const originalText = button.innerHTML;

    button.disabled = true;
    button.innerHTML = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      button.innerHTML = '✓ Added!';
      setTimeout(() => {
        button.disabled = false;
        button.innerHTML = originalText;
      }, 2000);

      // Update mini cart
      if (typeof updateMiniCart === 'function') {
        updateMiniCart();
      }
    })
    .catch(error => {
      console.error('Error:', error);
      button.disabled = false;
      button.innerHTML = originalText;
      alert('Error adding item to cart.');
    });
  });
});

// Handle Spotlight Add to Cart Forms (products-section)
document.querySelectorAll('.spotlight-add-to-cart-form').forEach(function(form) {
  form.addEventListener('submit', function(event) {
    event.preventDefault();

    const button = this.querySelector('.spotlight-cart-btn');
    const variantId = button.getAttribute('data-variant-id');
    const originalText = button.innerHTML;

    button.disabled = true;
    button.innerHTML = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      button.innerHTML = '✓ Added!';
      setTimeout(() => {
        button.disabled = false;
        button.innerHTML = originalText;
      }, 2000);

      // Update mini cart
      if (typeof updateMiniCart === 'function') {
        updateMiniCart();
      }
    })
    .catch(error => {
      console.error('Error:', error);
      button.disabled = false;
      button.innerHTML = originalText;
      alert('Error adding item to cart.');
    });
  });
});


// Function to update the mini cart UI dynamically
function updateMiniCart() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update cart count badges in header
      updateCartCount(cart.item_count);

      // Show the mini cart (if it's not visible yet)
      const miniCartElement = document.getElementById('mini-cart');
      if (miniCartElement) {
        miniCartElement.style.display = 'block';
      }

      const miniCartItemsContainer = document.getElementById('mini-cart-items');
      if (!miniCartItemsContainer) return;
      
      miniCartItemsContainer.innerHTML = ''; // Clear existing items

      // Check if cart has items
      if (cart.item_count > 0) {
        cart.items.forEach((item, index) => {
          var itemElement = document.createElement('div');
          itemElement.classList.add('mini-cart-item');
          itemElement.innerHTML = `
            <div class="d-flex">
              <img src="${item.image}" alt="${item.product_title}">
              <div class="item-details">
                <span>${item.quantity} x ${item.product_title}</span>
                <span>${(item.line_price / 100).toFixed(2)} €</span>
              </div>
              <span class="item-remove" onclick="removeItem(${index + 1})" style="cursor: pointer;">×</span>
            </div>
          `;
          miniCartItemsContainer.appendChild(itemElement);
        });

        // Update total price
        const miniCartTotal = document.getElementById('mini-cart-total');
        if (miniCartTotal) {
          miniCartTotal.innerHTML = `Total: ${(cart.total_price / 100).toFixed(2)} €`;
        }
      } else {
        miniCartItemsContainer.innerHTML = '<p>No items in the cart</p>';
        const miniCartTotal = document.getElementById('mini-cart-total');
        if (miniCartTotal) {
          miniCartTotal.innerHTML = 'Total: 0.00 €';
        }
      }
    })
    .catch(error => console.error('Error updating mini cart:', error));
}

// Function to update cart count badges in header
function updateCartCount(count) {
  const cartCountMobile = document.getElementById('cart-count-mobile');
  const cartCountDesktop = document.getElementById('cart-count-desktop');
  
  if (cartCountMobile) {
    cartCountMobile.textContent = count;
  }
  
  if (cartCountDesktop) {
    cartCountDesktop.textContent = count;
  }
}

// Function to remove an item from the cart
function removeItem(lineIndex) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line: lineIndex,
      quantity: 0
    })
  })
  .then(response => response.json())
  .then(data => {
    // Update mini cart UI after removing item
    updateMiniCart();
  })
  .catch(error => {
    console.error('Error removing item:', error);
    alert('Error removing item from cart. Please try again.');
  });
}


// Function to show success message after adding to cart
function showSuccessMessage(button) {
  // Ensure that the button exists and is part of the DOM
  if (!button) return;  // Exit if button is undefined or not part of DOM

  // Create a new success message
  var successMessage = document.createElement('div');
  successMessage.classList.add('add-to-cart-success');
  successMessage.innerHTML = 'Item added to cart!';

  // Find the product container (parent of the button)
  var productContainer = button.closest('.product-card'); // Adjust this selector if needed

  if (productContainer) {
    // Append the success message below the Add to Cart button
    productContainer.appendChild(successMessage);

    // Display the success message
    successMessage.style.display = 'block';

    // Hide success message after 3 seconds
    setTimeout(function() {
      successMessage.style.display = 'none';
    }, 3000);
  }
}



// Close mini cart when the close button is clicked
document.getElementById('close-mini-cart').addEventListener('click', function() {
  document.getElementById('mini-cart').style.display = 'none';
});
